import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Container, Grid, useMediaQuery } from '@material-ui/core'
import { SimpleLoading, PromotionalFooterPure, ButtonHLPure } from '../../pures'
import { BusinessAdministrationConfigurationsView } from '../../views'
import {
  HeaderHLPure,
  FilterHLPure,
  GridHLPure,
  SearchBarHLPure,
  ButtonAddHLPure,
} from '../../pures'
import './business-administration-panel.css'
import { NIL as NIL_UUID } from 'uuid'
import GridCustom from '../../pures/gridCustom/gridCustom.pure'

const BusinessAdministrationPanelView = (props) => {
  const { clientCompany, userInformation, imageProfile, registryTypes, pathView } = props
  const { t } = useTranslation()
  const [dataUser, setDataUser] = useState(clientCompany)

  const [selectedValueFilter, setSelectedValue] = useState(t('businessAdministrationPanelView.options.all'))
  const [searchValue, setSearchValue] = useState('')
  const showCompanyName = useMediaQuery('(max-width: 1360px)')
  const showStatus = useMediaQuery('(max-width: 1120px)')
  const showIconOne = useMediaQuery('(max-width: 1060px)')
  const showIconTwo = useMediaQuery('(max-width:860px)')
  const showIconThree = useMediaQuery('(max-width:650px)')
  const showImgProfile = useMediaQuery('(max-width: 960px)')
  const [selectedUser, setSelectedUser] = useState({})
  const [showDetails, setShowDetails] = useState(false)
  const [nameComponentUser, setNameComponentUser] = useState('')
  const [headerTitleinDetail, setHeaderTitleinDetail] = useState({
    clicked: false,
    name: '',
  })
  const isMobile = useMediaQuery('(max-width:560px)')
  //Filter Function, convert to boolean
  const strToboolean = (value) => {
    if (value && typeof value === 'string') {
      if (value === t('businessAdministrationPanelView.options.active')) return true
      if (value === t('businessAdministrationPanelView.options.inactive')) return false
    }
    return value
  }

  //Filter Function, get selected value
  const filterChange = (e) => {
    const selectedOption = !props.procedureManager ? strToboolean(e.target.value) : e.target.value
    setSelectedValue(selectedOption)
  }

  //Update state information from grid
  useEffect(() => {
    setDataUser(clientCompany)
  }, [clientCompany])

  //Filter Function, filter elements and update grid
  useEffect(() => {
    if (props.procedureManager) {
      let usersCopy = [...clientCompany]
      let dataUpadate
      switch (selectedValueFilter) {
        case 'businessActive':
          dataUpadate = usersCopy.filter(
            (user) => user.company.status && user.company.registryType === process.env.REACT_APP_STATUS_APPLICATION_TYPE_BUSINESS_REASON
          )
          break
        case 'businessInactive':
          dataUpadate = usersCopy.filter(
            (user) => !user.company.status && user.company.registryType === process.env.REACT_APP_STATUS_APPLICATION_TYPE_BUSINESS_REASON
          )
          break
        case 'entityActive':
          dataUpadate = usersCopy.filter(
            (user) => user.company.status && user.company.registryType ===
              (process.env.REACT_APP_STATUS_APPLICATION_TYPE_PERSON_ENTITY || process.env.REACT_APP_STATUS_APPLICATION_TYPE_ORGANIZATION_ENTITY)
          )
          break
        case 'entityInactive':
          dataUpadate = usersCopy.filter(
            (user) => !user.company.status && user.company.registryType ===
              (process.env.REACT_APP_STATUS_APPLICATION_TYPE_PERSON_ENTITY || process.env.REACT_APP_STATUS_APPLICATION_TYPE_ORGANIZATION_ENTITY)
          )
        default:
          return
      }
      return setDataUser(dataUpadate)
    }
    let usersCopy = [...clientCompany]
    let dataUpadate = usersCopy.filter(
      (user) => user.company.status === selectedValueFilter
    )
    setDataUser(dataUpadate)
  }, [selectedValueFilter])

  // Search Function, get value search input
  const searchChange = (e) => {
    setSearchValue(e.target.value)
  }

  //Search Function, search elements and update grid
  useEffect(() => {
    let usersCopy = [...clientCompany]
    let dataUpdateFilter = []
    if (props.procedureManager) {
      switch (selectedValueFilter) {
        case 'businessActive':
          dataUpdateFilter = usersCopy.filter(
            (user) => user.company.status && user.company.registryType === process.env.REACT_APP_STATUS_APPLICATION_TYPE_BUSINESS_REASON
          )
          break
        case 'businessInactive':
          dataUpdateFilter = usersCopy.filter(
            (user) => !user.company.status && user.company.registryType === process.env.REACT_APP_STATUS_APPLICATION_TYPE_BUSINESS_REASON
          )
          break
        case 'entityActive':
          dataUpdateFilter = usersCopy.filter(
            (user) => user.company.status && user.company.registryType ===
              (process.env.REACT_APP_STATUS_APPLICATION_TYPE_PERSON_ENTITY || process.env.REACT_APP_STATUS_APPLICATION_TYPE_ORGANIZATION_ENTITY)
          )
          break
        case 'entityInactive':
          dataUpdateFilter = usersCopy.filter(
            (user) => !user.company.status && user.company.registryType ===
              (process.env.REACT_APP_STATUS_APPLICATION_TYPE_PERSON_ENTITY || process.env.REACT_APP_STATUS_APPLICATION_TYPE_ORGANIZATION_ENTITY)
          )
          break
        default:
          dataUpdateFilter = [...clientCompany]
          break
      }
    } else dataUpdateFilter =
      selectedValueFilter === t('businessAdministrationPanelView.options.all')
        ? clientCompany
        : usersCopy.filter((client) => client.status === selectedValueFilter)

    let dataUpdateSearch = dataUpdateFilter.filter((client) => {
      return (
        client.clientName.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0
      )
    })
    setDataUser(dataUpdateSearch)
  }, [searchValue, selectedValueFilter])

  const setHeaderTitle = () => {
    const name = headerTitleinDetail.name || nameComponentUser
    switch (name) {
      case '':
        return t('businessAdministrationPanelView.title')
      case t('businessAdministrationPanelView.grid.actions.address'):
        return (
          t('businessAdministrationPanelView.businessAddress') +
          ' ' +
          selectedUser.clientName
        )
      case t('businessAdministrationPanelView.grid.actions.sat'):
        return (
          t('businessAdministrationPanelView.certifiesSAT') +
          ' ' +
          selectedUser.clientName
        )
      case t('businessAdministrationPanelView.grid.actions.disable'):
        return (
          t('businessAdministrationPanelView.disableCompany') +
          ' ' +
          selectedUser.clientName
        )
      case t('businessAdministrationPanelView.grid.actions.view.detail'):
        return t('businessAdministrationPanelView.grid.actions.view.detail')
      case t('businessAdministrationPanelView.addCompany'):
        return t('userAdministrationView.saveUserTitle')
      default:
        return t('businessAdministrationPanelView.title')
    }
  }

  useEffect(() => {
    if (headerTitleinDetail.clicked) {
      setHeaderTitle()
    }
    setHeaderTitle()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameComponentUser, headerTitleinDetail])

  const IconOneActive = ({ dataItem }) => {
    return (
      <div className='cellActions-containerBtnsDetails'>
        <button
          className='cellActions-btn'
          onClick={() => {
            setSelectedUser(dataItem)
            setNameComponentUser(t('businessAdministrationPanelView.grid.actions.address'))
            setShowDetails(true)
          }
          }
        // data-id={labelOneActions}
        >
          <p className='cellActions-textBotton'>
            {
              props.procedureManager
                ? dataItem.company.registryType === process.env.REACT_APP_STATUS_APPLICATION_TYPE_BUSINESS_REASON
                  ? t('businessAdministrationPanelView.grid.actions.address')
                  : t('businessAdministrationPanelView.grid.actions.entity')
                : t('businessAdministrationPanelView.grid.actions.address')
            }
          </p>
        </button>
      </div>
    )
  }

  const IconTwoActive = ({ dataItem }) => {
    if (props.procedureManager) {
      if (dataItem.company.registryType === process.env.REACT_APP_STATUS_APPLICATION_TYPE_BUSINESS_REASON) {
        return (
          <div className='cellActions-containerBtnsDetails'>
            <button
              className='cellActions-btn'
              onClick={() => {
                setSelectedUser(dataItem)
                setNameComponentUser(t('businessAdministrationPanelView.grid.actions.sat'))
                setShowDetails(true)
              }
              }
            // data-id={labelOneActions}
            >
              <p className='cellActions-textBotton'>{t('businessAdministrationPanelView.grid.actions.sat')}</p>
            </button>
          </div>
        )
      } else return null
    } else return (
      <div className='cellActions-containerBtnsDetails'>
        <button
          className='cellActions-btn'
          onClick={() => {
            setSelectedUser(dataItem)
            setNameComponentUser(t('businessAdministrationPanelView.grid.actions.sat'))
            setShowDetails(true)
          }
          }
        // data-id={labelOneActions}
        >
          <p className='cellActions-textBotton'>{t('businessAdministrationPanelView.grid.actions.sat')}</p>
        </button>
      </div>
    )
  }

  const IconThirdActive = ({ dataItem }) => {
    return (
      <div className='cellActions-containerBtnsDetails'>
        <button
          className='cellActions-btn'
          onClick={() => {
            setSelectedUser(dataItem)
            setNameComponentUser(t('businessAdministrationPanelView.grid.actions.disable'))
            setShowDetails(true)
          }
          }
        // data-id={labelOneActions}
        >
          <p className='cellActions-textBotton'>
            {
              props.procedureManager
                ? dataItem.company.registryType !== process.env.REACT_APP_STATUS_APPLICATION_TYPE_BUSINESS_REASON
                  ? dataItem.company.status
                    ? t('businessAdministrationPanelView.grid.actions.disable.entity')
                    : t('businessAdministrationPanelView.grid.actions.enable.entity')
                  : dataItem.company.status
                    ? t('businessAdministrationPanelView.grid.actions.disable')
                    : t('businessAdministrationPanelView.grid.actions.enable')
                : dataItem.company.status
                  ? t('businessAdministrationPanelView.grid.actions.disable')
                  : t('businessAdministrationPanelView.grid.actions.enable')
            }
          </p>
        </button>
      </div>
    )
  }

  return (
    <div className='standard-wrapper'>
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Container
          xs={12}
          lg={12}
          md={12}
          sm={12}
          spacing={4}
          className='businessAdministrationPanelView-container'
        >
          <Grid
            container
            className='businessAdministrationPanelView-body'
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
          >
            {showDetails && nameComponentUser ? (
              <BusinessAdministrationConfigurationsView
                nameComponentUser={nameComponentUser}
                selectedUser={selectedUser}
                hideShowDetails={() => {
                  setShowDetails(false)
                  setNameComponentUser('')
                  setHeaderTitleinDetail({ clicked: false, name: '' })
                }}
                registryTypes={registryTypes}
                toggleCompleted={props.toggleCompleted}
                token={props.token}
                setHeaderTitleinDetail={setHeaderTitleinDetail}
                forceRefresh={props.forceRefresh}
                validators={props.validators}
                optionsTypeBusiness={props.optionsTypeBusiness}
                optionsBusinessTurnover={props.optionsBusinessTurnover}
                contries={props.contries}
                clientCompany={clientCompany}
                showErrorRequesting={props.showErrorRequesting}
                showLoadingRequesting={props.showLoadingRequesting}
                showCompletedRequesting={props.showCompletedRequesting}
                showWarningRequesting={props.showWarningRequesting}
                message={props.message}
                toggleWarningRequesting={props.toggleWarningRequesting}
                toggleLoadingRequesting={props.toggleLoadingRequesting}
                toggleErrorRequesting={props.toggleErrorRequesting}
                toggleCompletedRequesting={props.toggleCompletedRequesting}
                onChangeImgProfile={props.onChangeImgProfile}
                setShowDetails={setShowDetails}
                setNameComponentUser={setNameComponentUser}
                userInformation={userInformation}
                imageProfile={imageProfile}
                procedureManager={props.procedureManager}
                pathView={pathView}
                t={t}
              />
            ) : (
              <>
                <Grid
                  item
                  lg={12}
                  md={12}
                  xs={12}
                  sm={12}
                  className='businessAdministrationPanelView-header'
                >
                  <HeaderHLPure
                    title={t('businessAdministrationPanelView.title')}
                  />
                </Grid>
                {/*Container primera seccion de items, fila*/}
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  className='businessAdministrationPanelView-navbar'
                >
                  {/*Cada componente puro, estara envuelto en un grid item */}
                  <Grid
                    item
                    lg={4}
                    md={4}
                    xs={12}
                    sm={12}
                    className='businessAdministrationPanelView-buttonHLPure'
                  >
                    <ButtonAddHLPure
                      nameBtn={(pathView === 'entities-administration') ? t('businessAdministrationPanelView.btn.add.entity') : t('businessAdministrationPanelView.addCompany')}
                      iconAdd
                      onClickBtn={() => {
                        setNameComponentUser(t('businessAdministrationPanelView.addCompany'))
                        setShowDetails(true)
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    lg={5}
                    md={4}
                    xs={12}
                    sm={12}
                    className='businessAdministrationPanelView-searchHLPure'
                  >
                    <SearchBarHLPure
                      placeholder={(pathView === 'entities-administration') ? t('businessAdministrationPanelView.search') : t('businessAdministrationPanelView.search.company')}
                      onSearchChange={(e) => searchChange(e)}
                      searchValue={searchValue}
                    />
                  </Grid>
                  <Grid
                    item
                    lg={3}
                    md={4}
                    xs={12}
                    sm={12}
                    className='businessAdministrationPanelView-filterHLPure '
                  >
                    <FilterHLPure
                      labelFilter={t('businessAdministrationPanelView.filter.by')}
                      options={props.optionsFilter}
                      nameOption='status'
                      valueItem={!props.procedureManager ? t('businessAdministrationPanelView.options.all') : 'value'}
                      defaultValue={selectedValueFilter}
                      optionsValue={t('businessAdministrationPanelView.options.all')}
                      onFilterChange={(e) => filterChange(e)}
                    />
                  </Grid>
                </Grid>
                <Grid
                  item
                  className='businessAdministrationPanelView-gridContainer'
                >
                  <GridCustom
                    {...props}
                    dataGrid={dataUser}
                    skip={0}
                    take={6}
                    selectedValueFilter={selectedValueFilter}
                    titleRow1={(pathView === 'entities-administration') ? t('businessAdministrationPanelView.grid.title.1.entity') : t('businessAdministrationPanelView.grid.title.1.company')}
                    fieldRow1={'clientName'}
                    titleRow4={t('businessAdministrationPanelView.grid.title.4')}
                    textSubtitle={!showStatus ? t('businessAdministrationPanelView.last.modification') : ''}
                    fieldTitle={'clientName'}
                    fieldSubtitle={!showStatus ? 'lastModificationDate' : ''}
                    fieldImg={'imgProfile'}
                    onFilterChange={filterChange}
                    onSelectedItem={setSelectedUser}
                    setShowDetails={setShowDetails}
                    setNameComponentUser={setNameComponentUser}
                    filter={true}
                    widthHeader={'gridHLPure-businessAdministrationPanelView-col1Header'}
                    column2Status={!showStatus}
                    title2Status={t('businessAdministrationPanelView.grid.title.3')}
                    field2Status={'status'}
                    iconOneActive={!showIconOne}
                    IconOneActive={IconOneActive}
                    iconTwoActive={!showIconTwo}
                    IconTwoActive={IconTwoActive}
                    iconThirdActive={!showIconThree}
                    IconThirdActive={IconThirdActive}
                    // IconFourthActive={IconFourthActive}
                    fieldExtra={'companyName'}
                    titleExtra={t('businessAdministrationPanelView.grid.title.2')}
                    widthExtra={100}
                    // headerClassName={''}
                    iconStatus
                    iconFifthActive
                    labelOneActions={t('businessAdministrationPanelView.grid.actions.address')}
                    labelTwoActions={t('businessAdministrationPanelView.grid.actions.sat')}
                    labelThirdActions={t('businessAdministrationPanelView.grid.actions.disable')}
                    labelFourthActions={t('businessAdministrationPanelView.grid.actions.view.detail')}
                    labelFifthActions={t('businessAdministrationPanelView.grid.actions.view.detail')}
                    widthHeaderCol1={'gridHLPure-cellItemStylesTh1'}
                    widthHeaderCol2={'gridHLPure-cellItemStyles2'}
                    widthHeaderCol3={'gridHLPure-cellItemStylesTh3'}
                    widthHeaderCol4={'gridHLPure-cellItemStylesHeader4'}
                    styleCol1={'gridHLPure-businessAdministration-cellItemStylesCol1'}
                    styleCol2={'gridHLPure-businessAdministration-cellItemStylesCol2'}
                    styleCol3={'gridHLPure-cellItemStylesCol3'}
                    styleCol4={'gridHLPure-businessAdministration-cellItemStylesCol4'}
                    // styleHeader4={}
                    activeDialog1={false}
                    iconAvatar={!showImgProfile}
                    columnFour
                    column2={!showCompanyName}
                    column2Title={t('businessAdministrationPanelView.grid.title.2')}
                    column2Field={'companyName'}
                    column2Classname='gridHLPure-cellItem2Cell'
                    column2HeaderClassname='gridHLPure-cellItem2Header'
                  />
                </Grid>
              </>
            )}
            {!nameComponentUser &&
              <Grid
                container
                style={{ justifyContent: 'flex-end' }}
              >
                <ButtonHLPure
                  nameBtn={t('button.return')}
                  onClickBtn={(pathView !== 'entities-administration') ? () => props.history.push('/configuration') : () => props.history.push('/help-desk')}
                />
              </Grid>
            }
            {/*Seccion de fila para footer */}
            <Grid item xs={12} lg={12} md={12} sm={12}>
              <PromotionalFooterPure />
            </Grid>
          </Grid>
          {/* </Grid> */}
        </Container>
      )}
    </div>
  )
}

export default BusinessAdministrationPanelView
